import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadFileResponse } from '~/core/models/upload.model';
import { environment } from "@env/environment";

@Injectable({
  providedIn: 'root'
})
export class UploadFile {

  private readonly url: string = environment.apiUrl;
  private readonly apiPath = this.url + '/api/v1';

  constructor(private readonly http: HttpClient) { }

  /**
   * @returns - An observable that emits the response from the server, which includes the batchId and sasUrl for uploading the file.
   */
  public updateClassification(): Observable<UploadFileResponse> {
    return this.http.post<UploadFileResponse>(`${this.apiPath}/upload/initialize`, null);
  }

  /**
   * @param file - The file to be uploaded to Azure Blob Storage using the provided SAS URL.
   * @param sasUrl - The SAS URL obtained from the server that grants permission to upload the file to Azure Blob Storage.
   * @returns - An observable that emits the response from the Azure Blob Storage service after attempting to upload the file. The response will indicate whether the upload was successful or if there were any errors.
   */
  public updateTheFile(file: File, sasUrl: string): Observable<any> {
    const headers = new HttpHeaders({
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type || 'application/octet-stream'
    });
    return this.http.put(`${sasUrl}`, file, { headers: headers });
  }

  /**
   * @description - This method is called after the file has been successfully uploaded to Azure Blob Storage. It notifies the server that the upload is complete and provides the batchId associated with the uploaded file. The server can then perform any necessary post-upload processing, such as validating the file or updating the database.
   * @param payload - An object containing the batchId that was received from the server during the initialization step. This batchId is used to identify the uploaded file and link it to any relevant records in the database.
   * @returns - An observable that emits the response from the server after notifying it that the upload is complete.
   */
  public uploadComplete(payload: { batchId: string }): Observable<UploadFileResponse> {
    return this.http.post<UploadFileResponse>(`${this.apiPath}/upload/${payload.batchId}/complete`, null);
  }


}
